module.exports = __webpack_public_path__ + "assets/img/29_261_big.761d5312.jpg";